import { PawPrint } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const PawPrintIcon = createLucideIcon(PawPrint);
